


















import { Vue, Component } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import Card from '@/components/Card.vue';
import SoftwareTab from './components/Software.tab.vue';
import CourseTab from './components/Course.tab.vue';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import { Order } from '@/store/modules/order';
import { ApiState } from '@/store/types/general.types';

@Component({
  components: {
    Container,
    Card,
    SoftwareTab,
    CourseTab
  }
})
export default class MyOrdersPage extends Vue {
  public activeTab = 0;

  @Action('order/getMyOrders')
  public getMyOrders!: () => void;

  @State((state: RootState) => state.order.orders)
  public orders!: Order[];

  @State((state: RootState) => state.order.apiState.getMyOrders)
  public getMyOrdersState!: ApiState;

  get isLoading() {
    return this.getMyOrdersState.loading;
  }

  public mounted() {
    this.getMyOrders();
  }

  public errorToast() {
    const responseText =
      'Unable to connect to payment gateway. Please try again later.';

    return this.$buefy.dialog.confirm({
      title: `Error`,
      message: `<p class="subtitle"> "${responseText}"<p>`,
      confirmText: 'Ok',
      type: 'is-primary'
    });
  }
}
